import React, { useState } from 'react';
import './InputField.css';

const InputField = ({ 
  label, 
  type = 'text', 
  icon, 
  placeholder, 
  value, 
  onChange, 
  error,
  showPasswordToggle = false 
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputType = showPasswordToggle ? (showPassword ? 'text' : 'password') : type;

  return (
    <div className="form-group">
      <label>{label}</label>
      <div className="input-wrapper">
        <span className="input-icon">{icon}</span>
        <input
          type={inputType}
          className={`form-control ${error ? 'is-invalid' : ''}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required
        />
        {showPasswordToggle && (
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowPassword(!showPassword)}
            title="顯示/隱藏密碼"
          >
            <span>{showPassword ? '🙈' : '👁️'}</span>
          </button>
        )}
      </div>
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

export default InputField;
